import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class PayrollTaxReportProvider {

  private _service: string = 'payroll';
  private _model: string = 'payrolltaxreport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public downTaxTemplate(params: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downTaxTemplate';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/payroll-tax-report/payroll-tax-report.ts